const route = {
    path: "/product-filing",
    name: "Product",
    meta: {
        layout: 'PageLayout'
    },
    children: [
        {
            path: "index",
            name: "ProductFiling",
            component: () => import( /*webpackChunkName: "recp-product-filing"*/ "./view/ProductFiling.vue"),
            meta: {
                title: "商品备案",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: true
            }
        },
        {
            path: "order",
            name: "ProductFilingOrder",
            component: () => import( /*webpackChunkName: "recp-product-filing"*/ "./view/ProductFilingOrder.vue"),
            meta: {
                title: "商品备案清单",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: true
            }
        },
        {
            path: "order-detail",
            name: "ProductFilingOrderDetail",
            component: () => import( /*webpackChunkName: "recp-product-filing"*/ "./view/ProductFilingOrderDetail.vue"),
            meta: {
                title: "RCEP原产地证书商品备案详情",
                isRequiredAuth: true,
                isRequiredEnterpriseAuth: true
            }
        }
    ]

}

export default route